import { FetchOutput } from "../../common-fetch/miscellaneous/fetchResult";
import { isAuthenticated } from "../hooks/useInitializeCartState";
import { isOrderCookie } from "../miscellaneous/isOrderCookie";
import { OrderState } from "./orderAtom";
import { requestCarts } from "./requestCarts";
import { requestOrders } from "./requestOrders";

export type RequestOrderOutput = {
  readonly order: OrderState;
  readonly tag: FetchOutput<unknown, unknown>["tag"];
};

export async function requestOrder(
  order: OrderState
): Promise<RequestOrderOutput> {
  if (!isOrderCookie()) {
    return { tag: "successful", order: { errors: [{ errorGroup: "Cart" }] } };
  } else if (await isAuthenticated()) {
    return requestOrders(order);
  } else {
    return requestCarts(order);
  }
}
